import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useState } from "react";
import CashHandoverDialog from "./cash-handover-dialog";
import { Tag } from "primereact/tag";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import CollectedAmountTraceDatatable from "../where-is-my-cash-report/CollectedAmountTraceDatatable";


interface CashTrackRow {
  invoiceDate: string;
  userID: number;
  invoicedBy: string;
  totalSubTotal: number;
  totalTaxAmount: number;
  totalCourierCharges: number;
  totalDiscountAmount: number;
  grossAmount: number;
  status?: string; // New field
  handoverAmount:number;
  unsettledAmount:number;
}

interface DeliveryCashDatatableProps {
  data: CashTrackRow[];
  loading: boolean;
  refreshData: () => void;
}


const DeliveryCashDatatable: React.FC<DeliveryCashDatatableProps> = ({ data, loading,refreshData }) => {

  const [showHandoverDialog, setShowHandoverDialog] = useState(false);
const [handoverData, setHandoverData] = useState<{ }>({
  
});
	const [cashVisible, setCashVisible] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState<CashTrackRow | null>(null)

  const sortedData = [...data].sort(
    (a, b) => new Date(b.invoiceDate).getTime() - new Date(a.invoiceDate).getTime()
  );

  const formatDate = (rowData: CashTrackRow) => {
    const dt = new Date(rowData.invoiceDate);
    return dt.toLocaleDateString("en-GB"); // e.g. 04/08/2025
  };

const statusBodyTemplate = (rowData: CashTrackRow) => {
  let status = "Pending";
  let severity: "success" | "warning" | "danger" | undefined = "warning";

  if (rowData.grossAmount === rowData.handoverAmount && rowData.unsettledAmount === 0) {
    status = "Settled";
    severity = "success"; // Green
  } else if (rowData.handoverAmount > 0 && rowData.unsettledAmount > 0) {
    status = "Partially Settled";
    severity = "warning"; // Yellow
  } else if (rowData.handoverAmount === 0 && rowData.unsettledAmount === rowData.grossAmount) {
    status = "Pending";
    severity = "danger"; // Red
  }

  return <Tag value={status} severity={severity} />;
};



const actionBodyTemplate = (rowData: CashTrackRow) => {
    const isSettled =
    rowData.grossAmount === rowData.handoverAmount &&
    rowData.unsettledAmount === 0;

  const handleClick = (row: CashTrackRow) => {
  setHandoverData(rowData);
  setShowHandoverDialog(true);
};

return (
      <div className="flex justify-content-center">
        <Button
          label="Cash Handover"
          icon="pi pi-money-bill"
          iconPos="left"
          severity="info"
          size="small"
          disabled={isSettled}
          onClick={() => handleClick(rowData)}
          className="text-sm px-3"
        />
      </div>
    );

};
  
  return (
    <div className="card border-noround p-2">
      <DataTable
        value={sortedData}
        loading={loading}
        paginator
        rows={10}
        rowsPerPageOptions={[5, 10, 20, 50]}
        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
        currentPageReportTemplate="{first} to {last} of {totalRecords}"
        
	  onRowClick={(e) => {
          setSelectedRowData(e.data as CashTrackRow);
          setCashVisible(true);
        }}
      >
        <Column header="Date" body={formatDate} style={{ width: "15%" }}/>
        <Column field="grossAmount" header="Total Cash" style={{ width: "15%" }} />
        <Column field="handoverAmount" header="Settled" style={{ width: "15%" }} />
        <Column field="unsettledAmount" header="Unsettled"  style={{ width: "15%" }}/>
        <Column field="status" header="Status" body={statusBodyTemplate} style={{ width: "15%" }}  />
        <Column header="Action" body={actionBodyTemplate} style={{ width: "15%" }}/>
      </DataTable>
      <CashHandoverDialog
        visible={showHandoverDialog}
         onHide={() => {
    setShowHandoverDialog(false);
    refreshData(); 
  }}
        data={handoverData}
        setLoading={() => {}}
      />

      {/* Collected Amount Details Dialog */}
      {selectedRowData && (
        <Dialog
          visible={cashVisible}
          style={{ width: "80vw" }}
          header={`Cash Report - ${selectedRowData.invoicedBy}`}
          onHide={() => setCashVisible(false)}
          modal
        >
          <CollectedAmountTraceDatatable
            visible={cashVisible}
            onHide={() => setCashVisible(false)}
            userID={selectedRowData.userID}
            userName={selectedRowData.invoicedBy}
            startDate={selectedRowData.invoiceDate}
            endDate={selectedRowData.invoiceDate}
          />
        </Dialog>
      )}
    </div>
  );
};

export default DeliveryCashDatatable;
